'use client';
/**
 * 从 document.cookie 中获取指定名称的 cookie 值
 * @param name cookie 名称
 * @returns cookie 值，如果不存在则返回 undefined
 */
export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift();
    return cookieValue ? decodeURIComponent(cookieValue) : undefined;
  }
  return undefined;
};

/**
 * 设置 cookie
 * @param name cookie 名称
 * @param value cookie 值
 * @param options 选项，如 domain, path, expires 等
 */
export const setCookie = (
  name: string,
  value: string,
  options: {
    domain?: string;
    path?: string;
    expires?: Date | string;
    maxAge?: number;
    secure?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
  } = {}
): void => {
  if (typeof document === 'undefined') return;

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.domain) cookieString += `;domain=${options.domain}`;
  if (options.path) cookieString += `;path=${options.path}`;
  if (options.expires)
    cookieString += `;expires=${options.expires instanceof Date ? options.expires.toUTCString() : options.expires}`;
  if (options.maxAge !== undefined) cookieString += `;max-age=${options.maxAge}`;

  // sameSite=none 必须配合 secure 使用
  const isSecure = options.secure || options.sameSite === 'none';
  if (isSecure) cookieString += ';secure';
  if (options.sameSite) cookieString += `;SameSite=${options.sameSite}`;

  document.cookie = cookieString;
};
